<template>
  <div class="page quality-page">
    <h1>{{ page.heading }}</h1>
    <p class="page-intro">
      从产区的种植管理，到工厂里的加工环节，再到产地直播，这些是我们愿意公开讲清楚的部分。
    </p>
    <ContactFriend placement="hero" />
    <section class="quality-card">
      <h2>原料来自产区</h2>
      <p>石斛原料来自云南龙陵的种植基地，三七来自云南文山，灵芝原料来自高黎贡山一带。</p>
    </section>
    <section class="quality-card">
      <h2>产品形态</h2>
      <p>石斛系列以即食原浆为主，另外还有三七粉、灵芝孢子粉、灵芝菌汤包与精油等不同形态。</p>
    </section>
    <section class="quality-card">
      <h2>产地溯源直播</h2>
      <p>品牌会通过溯源直播展示种植基地与加工现场，让原料来源可以被直接看到。</p>
    </section>
    <section class="quality-card">
      <h2>资质与检测资料</h2>
      <p>
        具体规格、配料、执行标准与相关资质材料，会随产品批次与包装标示，也可以
        <a href="/contact.html">联系企业顾问</a>索取。
      </p>
    </section>
  </div>
</template>

<script>
import ContactFriend from '@/components/ContactFriend.vue'
import { resolvePage } from '@/content/siteContent.mjs'

const page = resolvePage('/quality.html')

export default {
  name: 'QualityPage',
  components: {
    ContactFriend
  },
  data() {
    return { page }
  }
}
</script>

<style scoped>
.page {
  max-width: 960px;
  margin: 0 auto;
  padding: 20px 16px 48px;
  text-align: left;
}

h1 {
  color: #4b0082;
  font-size: 1.5em;
  margin: 0 0 8px;
}

h2 {
  color: #4b0082;
  font-size: 1.1em;
  margin: 0 0 6px;
}

.page-intro,
p {
  color: #333;
  line-height: 1.8;
  margin: 0;
}

.quality-card {
  background: #fff;
  padding: 16px;
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(75, 0, 130, 0.06);
  margin-top: 14px;
}

a {
  color: #6a1bb0;
}
</style>
